import { Injectable } from '@angular/core';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class FuseMatchMediaService extends UnsubscribeOnDestroy {
    activeMediaQuery: string;
    onMediaChange: BehaviorSubject<string> = new BehaviorSubject<string>('');

    /**
     * Constructor
     *
     * @param {MediaObserver} _mediaObserver
     */
    constructor(private _mediaObserver: MediaObserver) {
        super();

        // Set the defaults
        this.activeMediaQuery = '';

        // Initialize
        this._init();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Initialize
     *
     * @private
     */
    private _init(): void {
        this._mediaObserver
            .asObservable()
            .pipe(debounceTime(500), distinctUntilChanged(), takeUntil(this._unsubscribeAll))
            .subscribe((changes: MediaChange[]) => {
                if (!changes || changes.length === 0) return;

                const activeChange = changes[0]; // usually the first one is the active breakpoint

                if (this.activeMediaQuery !== activeChange.mqAlias) {
                    this.activeMediaQuery = activeChange.mqAlias;
                    this.onMediaChange.next(activeChange.mqAlias);
                }
            });
    }
}
